import axios from 'axios';
import Swal from 'sweetalert2';

export const getAllLeaveAllocations = async ({ search, setLoading }) => {
  try {
    setLoading(true);
    const userId = JSON.parse(localStorage.getItem("user")).data._id;
    const response = await axios.get(`/allocate-leaves?user=${userId}&search=${search}`);
    setLoading(false);
    console.log(response.data);
    return response.data;
  } catch (error) {
    setLoading(false);
    console.error("Error fetching leave allocations:", error);
    return [];
  }
};

export const deleteLeaveAllocation = async (id) => {
  try {
    const response = await axios.delete(`/allocate-leaves/${id}`);
    // Check HTTP status code instead of response.ok
    if (response.status !== 200) {
      const errorData = response.data;
      throw new Error(errorData.message || 'Failed to delete leave allocation');
    }
    return response.data;
  } catch (error) {
    console.error("Error deleting leave allocation:", error.message);
    throw error;
  }
};

export const saveLeaveAllocations = async (leaveAllocations, setLoading) => {
  try {
    setLoading(true);

    const formattedLeaveAllocations = leaveAllocations.map(allocation => ({
      employee: allocation.employee,
      leaveBalances: allocation.leaveBalances.map(item => ({
        leaveType: item.leaveType,
        leaveCount: parseInt(item.leaveCount), // Ensure number
        initialQuota: parseInt(item.leaveCount) // Include initialQuota
      })),
      finacialYear: allocation.finacialYear, // Fixed typo in variable name
      financialYear: allocation.finacialYear // Send both for compatibility
    }));

    console.log('Sending payload:', formattedLeaveAllocations); // Debug log

    const response = await axios.post('/allocate-leaves', formattedLeaveAllocations);
    const { allProcessedAllocations, skippedAllocations } = response.data;
    Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: 'Successfully saved allocations',
    });
    console.log('Skipped allocations:', skippedAllocations);

    if (skippedAllocations.length > 0) {
      const skippedList = skippedAllocations
        .map(item => `Employee: ${item.employeeName.first_name} ${item.employeeName.last_name}, Leave Type: ${item.leaveTypeName}`)
        .join('<br>');

      await Swal.fire({
        icon: 'warning',
        title: 'Skipped Allocations',
        html: `Following leave allocations were skipped due to duplicates:<br>${skippedList}`,
      });
    }

    return allProcessedAllocations;
  } catch (error) {
    console.error('Error saving allocations:', error.message);
    await Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.response?.data?.error || 'Failed to save leave allocations',
    });
    throw error;
  } finally {
    setLoading(false);
  }
};

export const updateLeaveAllocation = async (allocationId, employee, leaveBalances, financialYear, setLoading) => {
  try {
    setLoading(true);
    const response = await axios.put('/allocate-leaves', {
      allocationId,
      employee,
      leaveBalances: leaveBalances.map(item => ({
        leaveType: item.leaveType,
        leaveCount: parseInt(item.leaveCount),
        initialQuota: parseInt(item.leaveCount)
      })),
      financialYear
    });
    setLoading(false);
    await Swal.fire({
      icon: 'success',
      title: 'Success',
      text: 'Leave allocation updated successfully!',
    });
    return response.data;
  } catch (error) {
    setLoading(false);
    console.error("Error updating leave allocation:", error);
    if (error.response && error.response.status === 400) {
      await Swal.fire({
        icon: 'warning',
        title: 'Warning',
        text: error.response.data.message,
      });
    } else {
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Failed to update leave allocation',
      });
    }
    throw error;
  }
};

export const filteredTableData = async ({ epf_number, empType, departmentName, leaveType }) => {
  try {
    const response = await axios.get('/leaves-table-data', {
      params: {
        leaveTypeId: leaveType,
        departmentName,
        employee_type: empType,
        epf_number
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const fetchSearchAllocation = async ({ name, epf_number, leaveType, employeeType, department, finacialYear, setLoading }) => {
  try {
    setLoading(true);
    const response = await axios.get(`/search-allocations`, {
      params: {
        name,
        epf_number,
        leaveType,
        employeeType,
        department,
        finacialYear
      },
      headers: {
        'Cache-Control': 'no-cache'
      }
    });
    setLoading(false);
    console.log(response, "This is Response");
    return response.data.data;
  } catch (error) {
    setLoading(false);
    await Swal.fire({
      title: 'Error!',
      text: error.response ? error.response.data.message : 'An error occurred while fetching deductions.',
      icon: 'error',
      confirmButtonText: 'Try Again'
    });
    throw error;
  }
};

export const getLeaveAllocationByEmployeeId = async (employeeId) => {
  try {
    const response = await axios.get(`/balance/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching leave allocation by employee ID:", error);
    throw error;
  }
};